import moment from 'moment';

export default function dateFormat(row) {
	if (row?.timestamp) {
		return moment(row.timestamp).local().format('lll');
	} else if (row?.date) {
		return moment(row.date).local().format('lll');
	} else return null;
}
